export const addressType = {
  BILLING: 'BILLING',
  SHIPPING: 'SHIPPING',
  CONTACT: 'CONTACT',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const STATUS = [
  { value: 'ALL', text: 'ทั้งหมด' },
  { value: 'WAITING', text: 'รออนุมัติ' },
  { value: 'APPROVED', text: 'อนุมัติแล้ว' },
  { value: 'PAID', text: 'จ่ายแล้ว' },
  { value: 'COMPENSATION', text: 'จ่ายรายเดือน' },
  { value: 'CANCEL', text: 'ไม่อนุมัติ' },
]

export const STATUSTEXTSELECTOR = (status) => {
  switch (status) {
    case STATUS[0].value:
      return STATUS[0].text
    case STATUS[1].value:
      return STATUS[1].text
    case STATUS[2].value:
      return STATUS[2].text
    case STATUS[3].value:
      return STATUS[3].text
    case STATUS[4].value:
      return STATUS[4].text
    case STATUS[5].value:
      return STATUS[5].text
    default:
      return 'ไม่ระบุ'
  }
}

export const STATUSCOLORSELECTOR = (status) => {
  switch (status) {
    case STATUS[0].value:
      return '#97A0AF'
    case STATUS[1].value:
      return STATUS[1].text
    case STATUS[2].value:
      return '#38B47F'
    case STATUS[3].value:
      return '#a9c268'
    case STATUS[4].value:
      return '#00B8D9'
    case STATUS[5].value:
      return '#FF5B37'
    default:
      return '#333'
  }
}

export const TIRE_PATCH_TYPE = [
  { value: 'WORMPILL', text: 'แทงหนอน' },
  { value: 'HOTSTEAM', text: 'สตีมร้อน' },
  { value: 'COLDSTEAM', text: 'สตีมเย็น' },
]
